import { render, staticRenderFns } from "./PreliminaryExam.vue?vue&type=template&id=3a61f04d&scoped=true&"
import script from "./PreliminaryExam.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryExam.vue?vue&type=script&lang=ts&"
import style0 from "./PreliminaryExam.vue?vue&type=style&index=0&id=3a61f04d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61f04d",
  null
  
)

export default component.exports